import { useRef, useState, useEffect } from "react";

import airport from "../assets/services/airport.jpg";
import meet from "../assets/services/meet.jpg";
import chauffeur from "../assets/services/chauffeur.jpg";
import tours from "../assets/services/tours.jpg";
import hotelTransfer from "../assets/services/hotel-transfer.jpg";
import fullday from "../assets/services/fullday.jpg";
import leisure from "../assets/services/leisure.jpg";
import booking from "../assets/services/booking.jpg";
import shopping from "../assets/services/shopping.jpg";

const services = [
  {
    title: "Airport Transfers",
    text: "Comfortable and reliable transfers to and from all UK airports for a smooth, stress-free journey.",
    img: airport
  },
  {
    title: "Meet & Greet",
    text: "Professional chauffeur meets you at arrivals, assists with luggage, and escorts you to your vehicle.",
    img: meet
  },
  {
    title: "Hotel & Accommodation Booking",
    text: "Assistance with booking hotels and serviced apartments.",
    img: booking
  },
  {
    title: "Chauffeur Service",
    text: "Luxury chauffeur-driven service for daily travel, business meetings, and special occasions.",
    img: chauffeur
  },
  {
    title: "UK Tours & City Trips",
    text: "Private tours across the United Kingdom to explore top cities in comfort and style.",
    img: tours
  },
  {
    title: "Hotel & City Transfers",
    text: "Reliable transfers between hotels, airports, and key destinations across the United Kingdom.",
    img: hotelTransfer
  },
  {
    title: "Full-Time Chauffeur",
    text: "Dedicated chauffeur and vehicle at your service for the entire day or throughout your stay.",
    img: fullday
  },
  {
    title: "Leisure & Sightseeing Trips",
    text: "Tailored leisure trips to enjoy countryside, landmarks in total comfort.",
    img: leisure
  },
  {
    title: "Shopping Trips",
    text: "Luxury shopping experiences to destinations like Bicester Village with private chauffeur service.",
    img: shopping
  }
];

function Services() {
  const scrollRef = useRef(null);
  const [canLeft, setCanLeft] = useState(false);
  const [canRight, setCanRight] = useState(true);

  const updateArrows = () => {
    const el = scrollRef.current;
    if (!el) return;

    const max = el.scrollWidth - el.clientWidth;

    setCanLeft(el.scrollLeft > 5);
    setCanRight(el.scrollLeft < max - 5);
  };

  useEffect(() => {
    updateArrows();
  }, []);

  const scroll = (dir) => {
    const el = scrollRef.current;
    if (!el) return;

    el.scrollBy({
      left: dir === "left" ? -420 : 420,
      behavior: "smooth"
    });
  };

  const handleMouseDown = (e) => {
    const el = scrollRef.current;
    el.isDown = true;
    el.startX = e.pageX;
    el.scrollStart = el.scrollLeft;
  };

  const handleMouseMove = (e) => {
    const el = scrollRef.current;
    if (!el || !el.isDown) return;

    const walk = e.pageX - el.startX;
    el.scrollLeft = el.scrollStart - walk;
  };

  const stopDrag = () => {
    const el = scrollRef.current;
    if (el) el.isDown = false;
  };

  return (
    <section className="services-horizontal">

      <h1 className="services-title">OUR SERVICES</h1>

      <div className="services-wrapper">

        <button
          className={`arrow left ${!canLeft ? "disabled" : ""}`}
          onClick={() => scroll("left")}
          disabled={!canLeft}
        >
          ‹
        </button>

        <div
          className="services-scroll"
          ref={scrollRef}
          onScroll={updateArrows}
          onMouseDown={handleMouseDown}
          onMouseMove={handleMouseMove}
          onMouseUp={stopDrag}
          onMouseLeave={stopDrag}
        >

          {services.map((s, i) => (
            <div className="service-card" key={i}>

              {/* FIXED IMAGE FRAME */}
              <div className="service-image">
                <img src={s.img} alt={s.title} />
              </div>

              <div className="service-overlay"></div>

              <div className="service-content">
                <h3>{s.title}</h3>
                <p>{s.text}</p>

<a
  className="service-btn"
  href={`https://wa.me/447826699446?text=Hello%20I%20am%20interested%20in%20${encodeURIComponent(
    s.title
  )}`}
  target="_blank"
  rel="noreferrer"
>
  Book Now
</a>

              </div>

            </div>
          ))}

        </div>

        <button
          className={`arrow right ${!canRight ? "disabled" : ""}`}
          onClick={() => scroll("right")}
          disabled={!canRight}
        >
          ›
        </button>

      </div>

    </section>
  );
}

export default Services;